import type { CvHandoffStatus, TailoredCV } from './tailored-cv-api';

export type CvHandoffStatusKey =
  | 'draft'
  | 'pendingCopy'
  | 'pendingTransfer'
  | 'claimedCopy'
  | 'claimedTransfer'
  | 'cancelled'
  | 'expired';

export function hasCvHandoff(cv: Pick<TailoredCV, 'handoff'>) {
  return Boolean(cv.handoff);
}

export function isCvHandoffSendable(cv: Pick<TailoredCV, 'handoff'>) {
  const status = cv.handoff?.status;
  return status === 'draft' || status === 'pending';
}

export function getCvHandoffStatusKey(
  cv: Pick<TailoredCV, 'handoff'>,
): CvHandoffStatusKey | null {
  const handoff = cv.handoff;
  if (!handoff) return null;
  if (handoff.status === 'pending') {
    return handoff.mode === 'transfer' ? 'pendingTransfer' : 'pendingCopy';
  }
  if (handoff.status === 'claimed') {
    return handoff.mode === 'transfer' ? 'claimedTransfer' : 'claimedCopy';
  }
  if (handoff.status === 'cancelled') return 'cancelled';
  if (handoff.status === 'expired') return 'expired';
  return 'draft';
}

export function getCvHandoffStatus(
  cv: Pick<TailoredCV, 'handoff'>,
): CvHandoffStatus | null {
  return cv.handoff?.status ?? null;
}

export function buildCvHandoffSearchText(cv: Pick<TailoredCV, 'handoff'>) {
  const handoff = cv.handoff;
  if (!handoff) return '';
  return [
    handoff.recipientName,
    handoff.recipientEmail,
    handoff.mode,
    handoff.status,
  ]
    .filter(Boolean)
    .join(' ');
}
